module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEcAAAAQCAYAAABEO2JQAAAAnElEQVRYhe2X4QqAIAyEW/T+r1zth7DGzSGCdbTvn52IHrtpct5sBWR/ewNfpszpUOZ0ON7ewAwi8hj79mn1qLW2OUinNUcPhcxo37w+Ol/5Taz04LaSvBleV2jNWfECoTXHg2Lh9VFoe44FGeNjgmKTQW9Or2Jmo0cdqyxKs9CaE13N0Ti7ndB61LHKeog1AFVYpkv9lcfQxmoFFx1+XCF49aH9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/zftb1-1.png
// module id = 717
// module chunks = 0